export default "__VITE_ASSET__81f56591__"